<re-toast
  [toastMessages]="(toastMessages$ | async)!"
  (removeToast)="onRemoveToast($event)"></re-toast>
<router-outlet />
